import { Button, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useButtonStyles from "../../styles/useButtonStyles";
import theme from "../../theme";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import BasicModal from "../ui/BasicModal";
import Loader from "../ui/Loader";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import { CommonButton } from "../../Shared/Components/Buttons/CommonButton";

const CutOffDate = () => {
  const { getUserPermission: getCutOffPermission } = usePermissionGetter(
    "finance",
    "cutoff_configuration"
  );
  const buttonStyles = useButtonStyles();
  const [fraudDetails, setFraudDetails] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [uploadError, setUploadError] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [cutoff_config, setCutOffDate] = useState<Dayjs | null>(dayjs());

  useEffect(() => {
    const fetchFraudDetectList = async () => {
      try {
        setLoading(true);

        const response = await axios.get(
          process.env.REACT_APP_API_URL +
            APIConstants.getFraudDetection +
            `?module=finance&feature=cutoff_configuration`
        );
        const data = response.data.result;
        const dataArray: any = [data];
        setFraudDetails(dataArray);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchFraudDetectList();
  }, []);

  const handleSubmit = async () => {
    let formData: any = {
      cutoff_config: cutoff_config,
      feature: "finance",
      module: "cutoff_configuration",
    };
    try {
      setLoading(true);
      const response = await axios.post(
        process.env.REACT_APP_API_URL +
          APIConstants.saveFraudDetection +
          `?module=finance&feature=cutoff_configuration`,
        formData
      );

      const responseData = response.data;
      const transformedResponse = {
        cutoff_config: responseData.cutoff_config,
      };
      const dataArray: any = [transformedResponse];
      setFraudDetails(dataArray);
    } catch (error) {
      setUploadError(true);
    } finally {
      setShowModal(true);
      setLoading(false);
    }
  };

  return (
    <Grid height={"100%"} display={"flex"} gap={2} px={6} py={8}>
      <Grid
        sx={{
          textAlign: "left",
        }}
        item
        marginBottom={4}
        xs={12}
        width={"100%"}
        px={2}
      >
        {fraudDetails.length > 0 &&
          fraudDetails.map((data: any, index) => {
            const configDate = data?.cutoff_config
              ? dayjs(data?.cutoff_config)
              : dayjs();
            const minDate = dayjs().isAfter(configDate) ? configDate : dayjs();
            const maxDate = dayjs().isAfter(configDate) ? dayjs() : configDate;
            const maxMonth = maxDate.add(1, "month").endOf("month");
            return (
              <>
                <Grid display={"flex"} gap={2} width={"100%"} mb={1} key={data}>
                  <Grid width={"25%"}>
                    <Typography
                      sx={{
                        fontFamily: theme.font?.fontFamily.primary,
                        fontSize: theme.font?.fontSize.tableHeader,
                        fontWeight: theme.font?.fontWeight.slightThick,
                        color: theme.color?.newTextColor,
                      }}
                    >
                      Cut Off Date
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker", "DatePicker"]}>
                        <DateTimePicker
                          sx={{
                            width: "100%",
                            size: "small",
                            "& .MuiInputBase-input": {
                              padding: "9px",
                            },
                          }}
                          defaultValue={configDate}
                          minDate={minDate}
                          maxDate={maxMonth}
                          onChange={(newDate) =>
                            newDate && setCutOffDate(newDate)
                          }
                          disableOpenPicker={!getCutOffPermission("update")}
                          readOnly={!getCutOffPermission("update")}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </Grid>
                  <Grid display={"flex"} alignItems={"end"}>
                    {getCutOffPermission("update") && (
                      <CommonButton
                        type="submit"
                        buttonTitle="Save"
                        variant="contained"
                        color="secondary"
                        onClick={() => handleSubmit()}
                        sx={{ width: "25%" }}
                      />
                    )}
                  </Grid>
                </Grid>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: "12px",
                    fontWeight: theme.font?.fontWeight.slightThick,
                    color: theme.color?.cutOffGrey,
                  }}
                >
                  Note: System default cut off date is 20th of every month.
                </Typography>
              </>
            );
          })}
        {showModal &&
          (uploadError ? (
            <BasicModal
              title={"Something went wrong"}
              success={false}
              setState={setShowModal}
            />
          ) : (
            <BasicModal
              title={"Cut-Off date updated successfully!"}
              success={true}
              setState={setShowModal}
            />
          ))}
        {loading && <BasicModal content={<Loader />} />}
      </Grid>
    </Grid>
  );
};

export default CutOffDate;
